import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import constants from '../constants';

class SelectShop extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            shops: [],
            apiData: {},
            errors: []
        };
        this.redirectLocations = {
            'menu': 'manage menu',
            'orders': 'manage orders'
        }
    };

    componentDidMount() {
        const initData = "query_id=AAFbinFaAAAAAFuKcVovSKWb&user=%7B%22id%22%3A1517390427%2C%22first_name%22%3A%22SecondNH%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22SecondNH%22%2C%22language_code%22%3A%22en%22%7D&auth_date=1653534720&hash=ff75fccf1de0e0b03fed30bbf8c574aa7fc30cc258dbf35dcfca1ce877dd3e69"//window.Telegram.WebApp.initData;
        const redirect = this.props.searchParams.get('redirect');
        try {
            if (initData) {
                fetch(`${constants.API_BASE_URL}/merchant/shop/retrieveAll${redirect==='orders'?'?orderStats=true':''}`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        initData,
                    })
                }).then(async res => await res.json())
                .then(json => {
                    this.setState({loading:false});
                    if (json.ok) {
                        this.setState({shops:json.data.shops});
                    } else {
                        this.setState({formErrors:typeof json.err === 'object'?[...json.err]:[json.err]});
                    };
                })
                .catch(err => {
                    this.setState({formErrors:err?[err.message]:'• An unexpected error occurred, please try again'});
                });
            } else {
                document.querySelector('#sessionExpired').classList.remove('d-none');
                document.querySelector('.container').classList.add('d-none');
            }
        } catch {}
    };

    render() {
        const redirect = this.props.searchParams.get('redirect');
        return (
            <div className="vh-100">
                <h1 id="sessionExpired" className="d-none">Your session has expired.<br/><br/>Close and launch this webpage from Telegram again.</h1>
                <div className="container my-3">
                    <h1 className="mb-3">Select shop to {this.redirectLocations[redirect]}</h1>
                    <hr />
                    {this.state.loading ? 
                        <div className="d-flex">
                            <div className="spinner-border" role="status"></div>
                            <h2 className="ms-3">Loading</h2>
                        </div> : <></>}
                    {this.state.shops.map((item, idx) => {
                        var unfufilled = 0;
                        var toBeCollected = 0;
                        var shop = item;
                        const orders = item.orders;
                        delete shop.shop;
                        if (orders) {
                            orders.forEach(order => {
                                if (order.status === "PAID") {
                                    unfufilled += 1;
                                } else if (order.status === "TO_COLLECT") {
                                    toBeCollected += 1;
                                };
                            });
                        };
                        return (
                            <div className="card bg-light mb-2" key={idx} onClick={() => this.props.navigate(`/merchant/shop/${item._id}/${redirect}`, {state:{shop}})}>
                                <div className="card-body">
                                    <h5 className="card-title">{item.displayName}</h5>
                                    {redirect==='orders'?<div>
                                        <span>{unfufilled} unfufilled</span>
                                        &nbsp;&bull;&nbsp;
                                        <span>{toBeCollected} to be collected</span>
                                    </div>:<></>}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    return <SelectShop {...props} navigate={navigate} searchParams={searchParams} setSearchParams={setSearchParams} />
}

export default WithNavigate; 